var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSendOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46516 9.28154L12.9717 3.69989L11.2387 13.1496L8.16974 10.6566L11.1498 6.87389C11.3207 6.65698 11.2834 6.3426 11.0665 6.17171C10.8496 6.00082 10.5352 6.03813 10.3643 6.25505L7.27636 10.1746L3.46516 9.28154ZM2.50687 10.0841L6.97216 11.1304V14.0697H7.97216V11.7844L11.0011 14.245C11.4138 14.5803 12.035 14.351 12.131 13.8279L14.0735 3.23561C14.1816 2.64619 13.5473 2.20228 13.0305 2.5057L2.31216 8.79889C1.76727 9.11881 1.89167 9.9399 2.50687 10.0841Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendOutline);
export default __webpack_public_path__ + "static/media/icon-send-outline.44f1898a46feee0261fc3d31cb18844a.svg";
export { ForwardRef as ReactComponent };